export const isForChildren = (genre: string): boolean => {
	if (!genre) return false;

	return !!genre.match(/children/gi);
};
